import React from 'react';
import { Box, Container, Typography, Stack, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid #e0e0e0',
        py: 4,
        backgroundColor: '#f9f9f9',
        mt: 8,
      }}
    >
      <Container maxWidth="md">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="textSecondary">
            © 2025 Pathvizor, Inc. All rights reserved.
          </Typography>

          <Stack direction="row" spacing={1}>
            <IconButton
              aria-label="LinkedIn"
              disabled
              sx={{ color: 'text.secondary' }}
            >
              <LinkedInIcon />
            </IconButton>
            <IconButton
              aria-label="Twitter"
              disabled
              sx={{ color: 'text.secondary' }}
            >
              <TwitterIcon />
            </IconButton>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
